<template>
  <div class="reportDetails">
    <commonHeader>
      <template #buttons>
        <el-button plain v-if="echoData.allowEditAll || echoData.allowEditExpenseInfo" @click="editBtn">编辑</el-button>
        <el-button plain v-if="echoData.allowRecallEdit" @click="recallBtn">召回修改</el-button>
        <el-button plain v-if="echoData.allowApprove" @click="agreeRejectBtn(0)">驳回</el-button>
        <el-button plain v-if="echoData.allowApprove" @click="agreeRejectBtn(1)">同意</el-button>
      </template>
    </commonHeader>
    <!-- 费用归属 -->
    <activistyCostAttribution v-if="requestFlage" ref="activistyCostAttribution" :echo-data="echoData" />
    <!-- 基本信息 -->
    <basicInfo v-if="requestFlage" :echo-data="echoData" />
    <!-- 活动信息 -->
    <activityInfo v-if="requestFlage" :echo-data="echoData" />
    <!-- 拟邀请客户 -->
    <div class="common_group" v-if="echoData.mactJoinCustomerList && echoData.mactJoinCustomerList.length > 0">
      <div class="title">
        <img src="@/assets/images/userIcon.png">
        <span>{{ $t('newApp.Customers.ctbi') }}</span>
      </div>
      <commonTable ref="statisticsTable" style="margin-bottom:20px" v-show="!$store.state.useSimplifiedForm" />
      <commonTable ref="reportDetailsCustomerTable" />
    </div>
    <!-- 活动附件 -->
    <div class="common_group" v-if="echoData.attachFileList && echoData.attachFileList.length > 0">
      <div class="title">
        <img src="@/assets/images/fileIcon.png">
        <span>{{ $t('file.aa') }}</span>
      </div>
      <commonTable ref="activityDetailsFileTable" />
    </div>
    <activityTargetValue v-if="!$store.state.useSimplifiedForm" :edit-echo-data="echoData" />
    <!-- 审批弹框 -->
    <agreeDialog :approved="assigneeName" :dialog-title="agreeDialogTitle" :echo-data="echoData"
      :agree-dialog-visible="agreeDialogVisible" @agreeSubHandle="agreeSubHandle"
      @dialogCloseHandle="agreeDialogCloseHandle" />
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import activistyCostAttribution from './children/activityQuery/activistyCostAttribution';
import basicInfo from './component/activityDetails/basicInformation/basicInfo';
import activityInfo from './component/activityDetails/basicInformation/activityInfo';
import agreeDialog from './component/activityDetails/activistyCostAttribution/agreeDialog';
import { activityQuery, activityQueryDetails } from './service';
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import activityTargetValue from '@/views/activitieList/children/activityQuery/activityTargetValue'

export default {
  data() {
    return {
      echoData: {},
      requestFlage: false,
      fileIconfont: {
        pdf: require('@/assets/images/iconfont-pdf.png'),
        doc: require('@/assets/images/iconfont-doc.png'),
        img: require('@/assets/images/iconfont-img.png'),
        ppt: require('@/assets/images/iconfont-ppt.png'),
        universal: require('@/assets/images/iconfont-universal.png'),
        xls: require('@/assets/images/iconfont-xls.png')
      },
      assigneeName: '',
      agreeDialogTitle: '',
      agreeRejectFlage: '', // 判断点的是同意还是驳回
      agreeDialogVisible: false
    };
  },
  components: {
    commonHeader,
    activistyCostAttribution,
    basicInfo,
    activityInfo,
    commonTable,
    agreeDialog,
    activityTargetValue
  },
  methods: {
    editBtn() {
      // 只能编辑费用归属
      this.$store.commit('newApplication/setEditFlag', 3);
      this.$router.push({
        path: '/editReportApplication',
        query: {
          activityCode: this.$route.query.activityCode,
          metaActive: this.$route.query.metaActive
        }
      });
    },
    fileDownloadBtn(row) {
      activityQueryDetails.getDownloadUrl(row.fileId).then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    loadFileTable() {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.Na'))
          ._data('fileName')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let format = row.fileName.split('.')[1];
              let imgUrl = '';
              switch (format) {
                case 'jpg':
                case 'png':
                case 'gif':
                  imgUrl = this.fileIconfont.img;
                  break;
                case 'pdf':
                  imgUrl = this.fileIconfont.pdf;
                  break;
                case 'doc':
                case 'docx':
                  imgUrl = this.fileIconfont.doc;
                  break;
                case 'ppt':
                case 'pps':
                case 'pptx':
                  imgUrl = this.fileIconfont.ppt;
                  break;
                case 'xls':
                case 'xlsx':
                  imgUrl = this.fileIconfont.xls;
                  break;
                default:
                  imgUrl = this.fileIconfont.universal;
              }
              return (
                <div class="table_file">
                  <img src={imgUrl} />
                  <span>{row.fileName}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('')
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="primary" onClick={() => { this.fileDownloadBtn(row); }}>
                    <i class="iconfont icon-shangchuan-icon" />
                    {this.$t('general.Download')}
                  </el-button>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('上传时间')
          ._data('createTime')
          ._width('300')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityDetailsFileTable.setColumn(column, {
          page: false
        });
        this.$refs.activityDetailsFileTable.loadStaticTable(this.echoData.attachFileList);
      });
    },
    agreeDialogCloseHandle() {
      this.agreeDialogVisible = false;
    },
    agreeRejectBtn(val) {
      let selected = [];
      if (this.$refs.activistyCostAttribution) {
        selected = this.$refs.activistyCostAttribution.getCheckedItem();
      }
      if (selected.length > 0) {
        activityQueryDetails.getReportProcessHistory(selected[0].id).then(res => {
          if (res.status === '200') {
            let { mactFlowLogReportList } = res.data;
            this.assigneeName = mactFlowLogReportList[mactFlowLogReportList.length - 1].assigneeName;
            this.agreeDialogTitle = val ? this.$t('btn.Agree') : this.$t('btn.Rejected');
            this.agreeRejectFlage = val;
            this.agreeDialogVisible = true;
          }
        });
      } else {
        this.$message.warning(this.$t('approvalCenter.PsaeiuFA'));
      }
    },
    agreeSubHandle(data) {
      let params = {
        reason: data.reason === '同意' ? '' : data.reason,
        directors: data.directors
      };

      let requestUrl = activityQueryDetails.reportApproval;
      if (!this.agreeRejectFlage) {
        requestUrl = activityQueryDetails.reportReject;
      }

      this.$store.commit('setSubPageLoading', true);
      Promise.all(this.$refs.activistyCostAttribution.getCheckedItem().map(item => {
        params.taskId = item.taskId;

        return new Promise((resolve, reject) => {
          requestUrl(params).then(res => {
            if (res.status === '200') {
              resolve(res);
            } else {
              reject(res);
            }
          });
        });
      })).then(res => {
        this.$store.commit('setSubPageLoading', false);
        this.agreeDialogVisible = false;
        if (this.agreeRejectFlage) {
          this.$message.success('审批成功');
        } else {
          this.$message.success('已驳回');
        }
        // 重新获取审批数量
        this.$store.dispatch('getPendingApprovalNum');
        this.$router.push({
          path: this.$route.query.metaActive ? this.$route.query.metaActive : '/reportList'
        });
      }).catch(() => {
        this.$store.commit('setSubPageLoading', false);
      });
    },
    recallBtn() {
      this.$confirm('确定召回修改该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        activityQuery.reportRecall(this.$route.query.activityCode).then(res => {
          if (res.status === '200') {
            this.$router.push('/drafts');
            this.$message.success('操作成功');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    loadStatisticsTable() {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.ca'))
          ._data('ca')
          ._width('15%')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noocc'))
          ._data('noocc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noucc'))
          ._data('noucc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolcc'))
          ._data('nolcc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noncc'))
          ._data('noncc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nocfuc'))
          ._data('nocfuc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolccx'))
          ._data('nolccx')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nonlcc'))
          ._data('nonlcc')
      );

      let column = tableRow._cols();
      this.$refs.statisticsTable.setColumn(column, {
        page: false
      });
    },
    loadCustomerTable() {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.CustomerName'))
          ._data('clientName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ci'))
          ._width('10%')
          ._data('isChannel')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.catt'))
          ._width('10%')
          ._data('accountMarked')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.accountMarked || '--'}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bo'))
          ._data('businessChance')
          ._width('10%')
      );
       tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.newBusOpp'))
          ._width('200px')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <span>
                  {
                    row.newBusOpp === 1 ? this.$t('general.yes') : (row.newBusOpp === 0 ? this.$t('general.no') : '--')
                  }
                </span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.pdty'))
          ._data('output')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cc'))
          ._data('columnName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccd'))
          ._data('isOldAccount')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccon'))
          ._data('name')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.ContactNumber'))
          ._data('phone')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccat'))
          ._data('entityType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cst'))
          ._data('channelContractType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.noc'))
          ._data('circleName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.wtb'))
          ._data('coconstructionOrNot')
          ._width('10%')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.reportDetailsCustomerTable.setColumn(column, {
          page: true
        });
        this.$refs.reportDetailsCustomerTable.loadStaticTable(this.echoData.mactJoinCustomerList, this.echoData.mactJoinCustomerList.length);
        const tableList = this.echoData.mactJoinCustomerList.filter((item, index, arr) => {
          return arr.findIndex(t => t.clientName === item.clientName) === index
        })
        this.loadStatisticsTable()
        let statistics = {
          ca: {},
          noocc: 0,
          noucc: 0,
          nolcc: 0,
          noncc: 0,
          nocfuc: 0,
          nolccx: 0,
          nonlcc: 0,
          tbps: 0,
        }

        tableList.forEach(item => {
          // 统计数据，拟邀请客户统计
          // 统计start
          let k = item.accountMarked ? (item.accountMarked === '--' ? '空' : item.accountMarked) : '空'
          if (!statistics.ca[k]) {
            statistics.ca[k] = 0
          }
          statistics.ca[k]++
          if (item.isOldAccount) {
            if (item.isOldAccount === '老客户') {
              statistics.noocc++
            }
          }
          if (item.columnName) {
            if (item.columnName === '营销系统客户') {
              statistics.noucc++
            }
            if (item.columnName === '列名客户') {
              statistics.nolcc++
            }
            if (item.columnName === '非列名客户') {
              statistics.noncc++
            }
            if (item.columnName === '营销系统渠道') {
              statistics.nocfuc++
            }
            if (item.columnName === '列名渠道') {
              statistics.nolccx++
            }
            if (item.columnName === '非列名渠道') {
              statistics.nonlcc++
            }
          } else {
            statistics.noncc++
          }
          // 统计end
        })
        // for (let i of this.statisticsTable) {
        //   this.$refs.statisticsTable.removeRow(i)
        // }
        let caContent = []
        for (let k in statistics.ca) {
          caContent.push(`${k}${this.$t('newApp.ADList.no')}：${statistics.ca[k]}`)
        }

        const statisticsRow = {
          ...statistics,
          ca: caContent.length > 0 ? caContent.join('，') : '--',
        }
        // this.$refs.statisticsTable.insertRow(statisticsRow)
        this.$refs.statisticsTable.loadStaticTable([statisticsRow]);
      });
    },
    getEchoData() {
      this.$store.commit('setSubPageLoading', true);
      activityQueryDetails.getBasicInfoData(this.$route.query.activityCode).then(res => {
        if (res.status === '200') {
          this.echoData = res.data;
          // 根据活动的 formType 设置简化表单状态（formType 为空时视为完整表单）
          this.$store.commit('setUseSimplifiedForm', this.echoData && this.echoData.marketActivity && this.echoData.marketActivity.formType === 'simplified');
          this.requestFlage = true;
          if (this.echoData.mactJoinCustomerList.length > 0) {
            this.loadCustomerTable();
          }
          if (this.echoData.attachFileList && this.echoData.attachFileList.length > 0) {
            this.loadFileTable();
          }
        }
        this.$store.commit('setSubPageLoading', false);
      });
    }
  },
  beforeDestroy () {
    this.$store.commit('setUseSimplifiedForm', false);
  },
  mounted() {
    if (this.$route.query.activityCode) {
      this.getEchoData();
    }
  }
};
</script>

<style scoped></style>
